import React from 'react';
import { ModalProps } from '../../../types/modal';
import { PricingTemplate } from '../../../types/contractor';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    Stack,
    Typography,
} from '@mui/material';
import PricingTemplatePreview from './PricingTemplatePreview';
import { CustomButton } from '../../../../layout/styledcomponents/CustomButton';
import { Close, Edit } from '@mui/icons-material';

interface TemplatePreviewModalProps extends ModalProps {
    template: PricingTemplate | null;
    handleEdit: () => void;
}

const TemplatePreviewModal = ({
    open,
    onClose,
    handleEdit,
    template,
}: TemplatePreviewModalProps) => {
    if (!template) return null;

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth='md'>
            <DialogTitle>
                Template Preview
                <IconButton
                    onClick={onClose}
                    sx={{ color: 'text.primary' }}
                    aria-label='close'
                >
                    <Close />
                </IconButton>
            </DialogTitle>
            <DialogContent sx={{ maxHeight: '600px', overflow: 'auto' }}>
                <Stack spacing={1}>
                    <Typography variant='subtitle2'>
                        Here is how your pricing template will appear to hosts:
                    </Typography>
                    <PricingTemplatePreview template={template} />
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button
                    variant='outlined'
                    startIcon={<Edit />}
                    onClick={handleEdit}
                >
                    Edit Template
                </Button>
                <CustomButton
                    variant='contained'
                    color='primary'
                    onClick={onClose}
                >
                    Close
                </CustomButton>
            </DialogActions>
        </Dialog>
    );
};

export default TemplatePreviewModal;
